<template>
  <div @click="emitClicked" class="cursor-pointer my-1 flex items-center gap-2">
    <input
      v-model="inputValue"
      class="cursor-pointer w-4 h-4 border-2 border-gray-700 rounded-full appearance-none  focus:outline-none"
      :class="error ? 'checked:bg-red-500 checked:border-red-500' : 'checked:bg-blue-500 checked:border-blue-500'"
      type="radio"
      :name="name"
      :value="value"
      :id="inputId"
      @change="emitChange"
      :required="required"
    />
    <label class="form-check-label cursor-pointer"> {{ label }} </label>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  name: String,
  value: String,
  label: String,
  error: String,
  required: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [Number, String],
    default: null
  } 
})

const emitChange = () => {
  emit('change', props.modelValue)
}

const emitClicked = () => {
  emit('update:modelValue', props.value)
  emit('clicked')
}

const inputValue = computed({
  get: () => props.modelValue,
  set: (newValue) => emit('update:modelValue', newValue)
})
</script>
